/* tslint:disable */
/* eslint-disable */
/**
 * Adgang API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface AuditEventActivityCountResponse
 */
export interface AuditEventActivityCountResponse {
    /**
     * 
     * @type {string}
     * @memberof AuditEventActivityCountResponse
     */
    activity?: string | null;
    /**
     * 
     * @type {any}
     * @memberof AuditEventActivityCountResponse
     */
    count?: any | null;
}

/**
 * Check if a given object implements the AuditEventActivityCountResponse interface.
 */
export function instanceOfAuditEventActivityCountResponse(value: object): value is AuditEventActivityCountResponse {
    return true;
}

export function AuditEventActivityCountResponseFromJSON(json: any): AuditEventActivityCountResponse {
    return AuditEventActivityCountResponseFromJSONTyped(json, false);
}

export function AuditEventActivityCountResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): AuditEventActivityCountResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'activity': json['activity'] === undefined ? undefined : json['activity'] === null ? null : json['activity'],
        'count': json['count'] === undefined ? undefined : json['count'] === null ? null : json['count'],
    };
}

export function AuditEventActivityCountResponseToJSON(json: any): AuditEventActivityCountResponse {
    return AuditEventActivityCountResponseToJSONTyped(json, false);
}

export function AuditEventActivityCountResponseToJSONTyped(value?: AuditEventActivityCountResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'activity': value['activity'],
        'count': value['count'],
    };
}

